import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { COLORS } from './tokens';

/**
 * E-commerce platform tile of D0c. Logos come from the assets already shipped
 * with the panel (src/assets/img/platforms/<id>.png).
 */
export default function PlatformTile({ platform, selected, onClick }) {
    let logo;

    try {
        logo = require(`../../../assets/img/platforms/${platform.id}.png`);
    } catch (e) {
        logo = require('../../../assets/img/platforms/other.png');
    }

    return (
        <ButtonBase
            type="button"
            onClick={onClick}
            sx={{
                width: '100%',
                minWidth: 0,
                height: 124,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1.25,
                px: 0,
                py: 2.5,
                backgroundColor: '#fff',
                border: selected ? `2px solid ${COLORS.green}` : '2px solid rgba(0,0,0,0.12)',
                borderRadius: '10px',
                position: 'relative',
                boxShadow: selected ? '0 4px 14px rgba(60,213,104,0.18)' : 'none',
                transition: 'border-color 150ms, box-shadow 150ms',
                '&:hover': { borderColor: selected ? COLORS.green : 'rgba(0,0,0,0.35)' }
            }}
        >
            <Box
                component="img"
                src={logo}
                alt={platform.name}
                sx={{ height: { xs: 54, md: 62 }, width: '100%', maxWidth: 200, objectFit: 'contain' }}
            />

            {selected && (
                <CheckCircleOutlineIcon sx={{ position: 'absolute', top: 8, right: 8, fontSize: 18, color: COLORS.green }} />
            )}
        </ButtonBase>
    );
}
